import About from "./components/About";
import { Banner } from "./components/Banner";
import { Header } from "./components/header/Header";
import { Industries } from "./components/Industries";
import { ExcelPoint } from "./components/ExcelPoint";
import { WhyChooseUs } from "./components/WhyChooseUs";
import { Blog } from "./components/Blog";
import { Contact } from "./components/Contact";
import {BrowserRouter,Routes,Route,} from "react-router-dom";
import { InnerBanner } from "./components/InnerBanner";
import { ContactThreeBox } from "./ContactThreeBox";
import { Footer } from "./components/footer/Footer";
// import MainService from "./components/MainService";
import Testimonial from "./components/Testimonial";
import { Services } from "./components/Services";
function App() {
  return (
    <>
     <BrowserRouter>
        <Header />
       <Routes>
        <Route path="/techsagaus" element={<>
             <Banner/>
             <About />
             <ExcelPoint />
             <Services  activeCardSer={6}/>
             <WhyChooseUs/>
             <Industries  activeCard={6}/>
             <Testimonial/>
             <Blog/>
             <Contact/>
         
            </>}>
        </Route>
        <Route path="/about" element={<>
          <InnerBanner heading={"About Us"}/>
             <About />
             <WhyChooseUs/>
             <Contact/>
            </>}>
        </Route>
        <Route path="/services" element={<>
          <InnerBanner heading={"Services"}/>
          <Services  activeCardSer={19}/>
            </>}>
        </Route>
        <Route path="/industries" element={<>
          <InnerBanner heading={"Industries"}/>
          <Industries  activeCard={19}/>
            </>}>
        </Route>
        <Route path="/contact" element={<>
          <InnerBanner heading={"Contact"}/>
          <ContactThreeBox/>
          <Contact/>
            </>}>
        </Route>
       </Routes>
       <Footer/>
     </BrowserRouter>
    </>
  );
}
export default App;


